export const CommonEnum = {
  YES: 'Yes',
  NO: 'No',

  CHECKALL: 'Check All',

  NEW: "NEW",
  QUEUED: "QUEUED",
  INPROCESS: "INPROCESS",
  COMPLETED: "COMPLETED",
  ERROR: "ERROR",
  PASS: "PASS",
  FAIL: "FAIL",

  SAVE: "Save",
  UPDATE: "Update",
  ADD: "Add",
  CLOSE: "close",
  COUNTINUE: "continue",

  //UserManagemnt
  MARK_AS_MASTERADMIN: 'Do you want to designate as Master Admin?',

  // Pop-up Alerts
  EXITPOPUP: 'Close?',
  UNINSTALLPOPUP: 'Proceed with uninstalling the app?',
  STRIPE_CONFIG: 'Set up payment account?',
  STRIPE_CONECT: 'Configure payment gateway to receive customer payments.',
  RETAINER_CONFIG: 'Confirm?',
  RETAINER_CONNECT: 'Amount will be deducted from retainer balance.',


  CONFIRM_CONNECT: 'Connect',
  CONFIRM_LATER: 'No',
  TIMESTAMP_CONFIG: 'Set up Timestamp?',
  TIMESTAMP_UPDATE: `Configure Timestamp to enable advanced features.`,

  ACCOUNTANT_CONFIRM: 'Confirm if you are an Accountant?',
  ACCOUNTANT_ASKING: `Select 'Yes' and submit your request if offering accounting services to access additional and advanced features.`,

  TOKEN_CONFIRMATION: 'Confirm?',
  TOKENMESSAGE_UPDATE: 'Click Yes to proceed with the session.',

  // FILEREMOVE :'Do you really want to remove this file... ?',
  FILEREMOVE: `Action cannot be undone`,
  REMOVEANSWER: `Are you sure you want to delete this answer?`,
  UNFAVTUTOR: `Are you sure you want to remove this AI tutor from your favorites?`,
  UNFAVTUTORTOOLS: `Are you sure you want to remove this AI tools from your favorites?`,
  CertificateIssue: `Once the issue certificate toggle is turned on, IT CANNOT BE TURNED OFF. If you turn the toggle on then you are obligated to issue certifications along with the services.`,
  SERVICEREMOVEFROMWEBSITE: `Do you want to proceed with deleting the services that were requested from the website?`,
  LOGOUT: `Proceed with logging out of the portal?`,
  YES_DELETE: 'Confirm deletion',
  YES_UNFAVOURITE: 'Confirm',
  YES_SWITCHON: 'Switch On',
  YES_LOGOUT_PORTAL: 'Confirm Logout',
  DELETED_SUCCESS: 'File deleted successfully',
  DELETED: 'Deleted!',
  CONFIRM_BUTTON_COLOR: '#0095e8',
  CANCEL_BUTTON_COLOR: '#d9214e',
  DELETECOMPANY: 'Feature coming soon.',
  IGNORE_CONFIRM: 'Proceed with ignoring?',
  PRIMARYCOMPANY: 'Set as primary company?',
  PRIMARYACCOUNTANT: 'Designate as primary accountant?',
  DISCONNECTACCOUNTANT: 'Disconnect from accountant company?',
  CONNECTACCOUNTANT: 'Connect to accountant company?',
  GRANTTOFIXUNCAT: 'Allow accountant access to uncategorized transactions?',
  REVOKETOFIXUNCAT: 'Revoke accountant access to uncategorized transactions?',
  PROPOSALAPPROVAL: 'Approve proposal?',
  PRICEBOOKCLIENTS_UNASSIGN: 'Remove client from assigned client list in Price Book?',
  DELETE_CARD_CONFIRM: 'Are you sure you want to delete this card?',
  SESSION_OR_LOGOUT_CONFIRM: 'Do you want to continue the session or logout?',








  // QuickBooks Connection
  CONFIRM: 'Confirm?',
  QBCONNECT: 'Connect with QuickBooks Online?',
  QBDISCONNECT: 'Disconnect from QuickBooks Online?.',


  NETWORKDISCONNECT: 'Disconnect from HonTru?',
  NETWORKCONNIGNORE: 'Ignore connecting to HonTru?',

  MENTORDISCONNECT: 'Are you sure you want to disconnect with mentor?',
  MENTORCONNIGNORE: 'Are you sure you want to ignore the connection?',
  INSTRUCTIONDELETE: 'Are you sure you want to delete this Prompt?',
  INSTRUCTIONINNERDELETE: 'Are you sure you want to delete this prompt line?',


  // Xero
  XERODISCONNECT: 'Disconnect from Xero?.',
  XEROMERGECOMPANY: 'Merge the companies?',
  XEROCREATECOMPANY: 'Create a new company?',



  // Invalid Form Responsecs & tags
  MAXTAGS: 'Limit of 5 tags allowed.',
  TAG_LENGTH: 5,
  TAG_TEXT: 'Tags',
  HASHTAGS_TEXT: '#hashtags',
  TOEMAILSTAGS: 'To Emails',
  EMAILS_TEXT: 'Emails',
  MAXLINKS: 'Limit of 3 links allowed',
  LINK_LENGTH: 3,
  LINK_TEXT: 'Links',
  CATEGORIES_LENGTH: 5,
  CATEGORIES_TEXT: 'Categories',
  MAXLANGUAGES: 'Maximum of 6 languages permitted',
  LANGUAGES_LENGTH: 6,
  language_TEXT: 'Languages',

  MAX_EMAILS: 'Limit of 5 emails permitted.',
  EMAILS_LENGTH: 100,
  EMAIL_TEXT: 'Emails',

  MANDOTORY_FIELDS: 'Mandatory fields must be filled in.',
  CUSTOMERISREQUIRED: 'A customer is necessary when marking as Billable or Taxable.',
  TO_EMAILS_REQUIRED: 'Recipient email addresses are required.',
  TAGS_REQUIRED: 'Tags must be provided.',
  GROUPS_REQUIRED: 'Groups/Members must be added.',
  ADD_CONTACTS: 'Kindly add contacts/clients.',
  DEADLINE_START_DATES: 'Deadline date must be after the start date.',
  ENDDATE_STARTDATE: 'The end date must be later than the start date.',
  FROMDATE_STARTDATE: 'The end date must be later than the start date.',
  ENDTIME_STARTTIME: 'The end time must be later than the start time.',
  DUEDATE_STARTDATE: 'The due date must be later than the start date.',
  LIVESTREAM_STARTDATE: 'The archive date must be after the session date',
  COMPLETEDATE_STARTDATE: 'The completion date must be later than the due date.',
  COMPLEDATE_STARTDATE_DUETDATE: 'The completion date must be later than both the start and due dates.',
  EFECTIVE_STARTDATE: 'The effective end date must be later than the start date.',
  DOB: 'Please choose the correct date.',
  SELECT_APP: 'Please select the application first.',
  CONTACTTEAM: 'please ener a valid security code',

  STOP_TIMER: 'Would you like to stop the timer?',

  MW_MAX_TABS: 'Note: The side navigation menu list allows a maximum of 5 items.',
  MW_MAX_BOTTOM_MENU: 'Note: Please select no more than 3 items for the bottom menu.',
  JOB_LINK: 'The job link has been copied.',

  BDRIVEVIEW: 'BDriveView',
  BDRIVETUTORVIEW: 'BDriveTutor',
  BDRIVEROOMVIEW: 'BDriveRoom',
  BDRIVESHARED: 'BDriveShared',
  BDRIVESTARRED: 'BDriveStarred',
  BDRIVERECENT: 'BDriveRecent',
  BDRIVEENTITES: 'BDriveEntityFolders',
  PORTALENTITES: 'PortalEntityFolders',
  ADVISORSCREEN: 'AdvisorScreen',
  HASHTAGSCREEN: 'HashTagScreen',
  GROUPSCREEN: 'GreoupScreen',
}

